import { Box } from "@/components/ui/box";
import { SafeAreaView } from "@/components/ui/safe-area-view";
import { VStack } from "@/components/ui/vstack";
import { ParamListBase, RouteProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { JSXElementConstructor, ReactElement } from "react";
import { WebBreadcrumbs } from "../menu/web.breadcrumbs";
import { cn } from "@gluestack-ui/nativewind-utils/cn";
import { Platform } from "react-native";

export type StackLayoutProps = {
  route: RouteProp<ParamListBase, string>;
  navigation: NativeStackNavigationProp<ParamListBase, string, undefined>;
  theme: ReactNavigation.Theme;
  children: ReactElement<any, string | JSXElementConstructor<any>>;
};

export function StackLayout({ children, ...rest }: StackLayoutProps) {
  const { navigation } = rest;
  const canDismiss = navigation.getState().routes.length > 1;

  return (
    <SafeAreaView className="h-full w-full bg-background-0">
      <VStack
        className={cn(["w-full", { "min-h-full": Platform.OS === "web" }])}
      >
        <Box
          className={cn([
            "min-h-fit",
            "hidden",
            "px-4",
            { "md:block": canDismiss },
          ])}
        >
          <WebBreadcrumbs />
        </Box>
        {children}
      </VStack>
    </SafeAreaView>
  );
}
